import airxPaths from "./airx.paths";
import customerPaths from "./customer.paths";
import vendorPaths from "./vendor.paths";

const pathRoute: Record<string, string[]> = {
  airx: airxPaths,
  vendor: vendorPaths,
  customer: customerPaths,
};
export default pathRoute;
